import React from "react";
import "./SmallText.css";

export default function SmallText(props) {
  return <p className="text text--small">{props.children}</p>;
}
